// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ==========================================
   Kubersetu Moneybro Page Glass Styles
   ========================================== */

.moneybro-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 6rem 1.5rem 4rem 1.5rem;
}

/* Hero Section */
.moneybro-hero {
  text-align: center;
  padding: 4rem 2rem;
  background: var(--bg-glass-card);
  backdrop-filter: blur(20px);
  border: 1px solid var(--border-glass);
  border-radius: var(--radius-lg);
  margin-bottom: 3rem;
  box-shadow: var(--shadow-lg);
}

.moneybro-hero h1 {
  font-size: clamp(2.5rem, 5vw, 3.5rem);
  margin-bottom: 1.5rem;
  font-weight: 800;
  color: #ffffff;
}

.moneybro-hero p {
  font-size: 1.1rem;
  margin-bottom: 2rem;
  color: var(--text-muted);
  max-width: 800px;
  margin-left: auto;
  margin-right: auto;
}

.moneybro-apply-btn {
  background: var(--grad-primary);
  color: #ffffff;
  border: none;
  padding: 1rem 2.5rem;
  font-size: 1.1rem;
  font-weight: 700;
  border-radius: var(--radius-full);
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 4px 15px rgba(245, 158, 11, 0.4);
}

.moneybro-apply-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(245, 158, 11, 0.6);
}

/* Features Section */
.moneybro-features {
  margin-bottom: 4rem;
}

.moneybro-features h2 {
  text-align: center;
  font-size: clamp(2rem, 4vw, 2.5rem);
  margin-bottom: 2.5rem;
  color: #ffffff;
  font-weight: 800;
}

.moneybro-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 2rem;
}

.moneybro-card {
  background: var(--bg-glass-card);
  backdrop-filter: blur(16px);
  padding: 2rem;
  border-radius: var(--radius-lg);
  text-align: center;
  border: 1px solid var(--border-glass);
  transition: all 0.3s ease;
}

.moneybro-card:hover {
  transform: translateY(-5px);
  border-color: rgba(255, 255, 255, 0.2);
  box-shadow: var(--shadow-lg);
}

.moneybro-icon {
  font-size: 3rem;
  margin-bottom: 1.5rem;
}

.moneybro-card h3 {
  font-size: 1.25rem;
  margin-bottom: 1rem;
  color: #ffffff;
  font-weight: 700;
}

.moneybro-card p {
  color: var(--text-muted);
  line-height: 1.6;
}

/* CTA Section */
.moneybro-cta {
  text-align: center;
  background: var(--grad-surface);
  padding: 4rem 2rem;
  border-radius: var(--radius-lg);
  margin-bottom: 3rem;
  border: 1px solid var(--border-glass);
  box-shadow: var(--shadow-lg);
}

.moneybro-cta h2 {
  font-size: 2rem;
  margin-bottom: 1rem;
  color: #ffffff;
}

.moneybro-cta p {
  font-size: 1.1rem;
  color: var(--text-muted);
  margin-bottom: 2rem;
}

.moneybro-cta-btn {
  background: var(--grad-primary);
  color: #ffffff;
  border: none;
  padding: 1rem 2.5rem;
  font-size: 1.1rem;
  font-weight: 700;
  border-radius: var(--radius-full);
  cursor: pointer;
  transition: all 0.3s ease;
}

.moneybro-cta-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 15px rgba(245, 158, 11, 0.4);
}

.moneybro-note {
  font-size: 0.85rem;
  color: var(--text-muted);
  margin-top: 1.5rem;
  display: block;
}

/* Customer Care Card */
.customer-care-card {
  background: var(--bg-glass-card);
  backdrop-filter: blur(16px);
  text-align: center;
  padding: 3rem 2rem;
  border-radius: var(--radius-lg);
  margin-bottom: 3rem;
  border: 1px solid var(--border-glass);
  box-shadow: var(--shadow-lg);
}

.customer-care-card h3 {
  font-size: 1.8rem;
  margin-bottom: 1rem;
  color: #ffffff;
}

.customer-care-card p {
  font-size: 1.1rem;
  margin-bottom: 2rem;
  color: var(--text-muted);
}

.customer-care-btn {
  display: inline-block;
  background: rgba(255, 255, 255, 0.1);
  color: #ffffff;
  border: 1px solid rgba(255, 255, 255, 0.2);
  padding: 1rem 2.5rem;
  font-size: 1.1rem;
  font-weight: 600;
  border-radius: var(--radius-full);
  text-decoration: none;
  transition: all 0.3s ease;
}

.customer-care-btn:hover {
  background: rgba(255, 255, 255, 0.2);
  transform: translateY(-2px);
}`, "",{"version":3,"sources":["webpack://./src/Components/Moneybro.css"],"names":[],"mappings":"AAAA;;+CAE+C;;AAE/C;EACE,iBAAiB;EACjB,cAAc;EACd,gCAAgC;AAClC;;AAEA,iBAAiB;AACjB;EACE,kBAAkB;EAClB,kBAAkB;EAClB,gCAAgC;EAChC,2BAA2B;EAC3B,qCAAqC;EACrC,+BAA+B;EAC/B,mBAAmB;EACnB,4BAA4B;AAC9B;;AAEA;EACE,qCAAqC;EACrC,qBAAqB;EACrB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,wBAAwB;EACxB,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,+BAA+B;EAC/B,cAAc;EACd,YAAY;EACZ,oBAAoB;EACpB,iBAAiB;EACjB,gBAAgB;EAChB,iCAAiC;EACjC,eAAe;EACf,yBAAyB;EACzB,8CAA8C;AAChD;;AAEA;EACE,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA,qBAAqB;AACrB;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,mCAAmC;EACnC,qBAAqB;EACrB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,gCAAgC;EAChC,2BAA2B;EAC3B,aAAa;EACb,+BAA+B;EAC/B,kBAAkB;EAClB,qCAAqC;EACrC,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;EAC3B,sCAAsC;EACtC,4BAA4B;AAC9B;;AAEA;EACE,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA,gBAAgB;AAChB;EACE,kBAAkB;EAClB,+BAA+B;EAC/B,kBAAkB;EAClB,+BAA+B;EAC/B,mBAAmB;EACnB,qCAAqC;EACrC,4BAA4B;AAC9B;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,wBAAwB;EACxB,mBAAmB;AACrB;;AAEA;EACE,+BAA+B;EAC/B,cAAc;EACd,YAAY;EACZ,oBAAoB;EACpB,iBAAiB;EACjB,gBAAgB;EAChB,iCAAiC;EACjC,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA;EACE,kBAAkB;EAClB,wBAAwB;EACxB,kBAAkB;EAClB,cAAc;AAChB;;AAEA,uBAAuB;AACvB;EACE,gCAAgC;EAChC,2BAA2B;EAC3B,kBAAkB;EAClB,kBAAkB;EAClB,+BAA+B;EAC/B,mBAAmB;EACnB,qCAAqC;EACrC,4BAA4B;AAC9B;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,wBAAwB;AAC1B;;AAEA;EACE,qBAAqB;EACrB,oCAAoC;EACpC,cAAc;EACd,0CAA0C;EAC1C,oBAAoB;EACpB,iBAAiB;EACjB,gBAAgB;EAChB,iCAAiC;EACjC,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;EACpC,2BAA2B;AAC7B","sourcesContent":["/* ==========================================\n   Kubersetu Moneybro Page Glass Styles\n   ========================================== */\n\n.moneybro-container {\n  max-width: 1200px;\n  margin: 0 auto;\n  padding: 6rem 1.5rem 4rem 1.5rem;\n}\n\n/* Hero Section */\n.moneybro-hero {\n  text-align: center;\n  padding: 4rem 2rem;\n  background: var(--bg-glass-card);\n  backdrop-filter: blur(20px);\n  border: 1px solid var(--border-glass);\n  border-radius: var(--radius-lg);\n  margin-bottom: 3rem;\n  box-shadow: var(--shadow-lg);\n}\n\n.moneybro-hero h1 {\n  font-size: clamp(2.5rem, 5vw, 3.5rem);\n  margin-bottom: 1.5rem;\n  font-weight: 800;\n  color: #ffffff;\n}\n\n.moneybro-hero p {\n  font-size: 1.1rem;\n  margin-bottom: 2rem;\n  color: var(--text-muted);\n  max-width: 800px;\n  margin-left: auto;\n  margin-right: auto;\n}\n\n.moneybro-apply-btn {\n  background: var(--grad-primary);\n  color: #ffffff;\n  border: none;\n  padding: 1rem 2.5rem;\n  font-size: 1.1rem;\n  font-weight: 700;\n  border-radius: var(--radius-full);\n  cursor: pointer;\n  transition: all 0.3s ease;\n  box-shadow: 0 4px 15px rgba(245, 158, 11, 0.4);\n}\n\n.moneybro-apply-btn:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 6px 20px rgba(245, 158, 11, 0.6);\n}\n\n/* Features Section */\n.moneybro-features {\n  margin-bottom: 4rem;\n}\n\n.moneybro-features h2 {\n  text-align: center;\n  font-size: clamp(2rem, 4vw, 2.5rem);\n  margin-bottom: 2.5rem;\n  color: #ffffff;\n  font-weight: 800;\n}\n\n.moneybro-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));\n  gap: 2rem;\n}\n\n.moneybro-card {\n  background: var(--bg-glass-card);\n  backdrop-filter: blur(16px);\n  padding: 2rem;\n  border-radius: var(--radius-lg);\n  text-align: center;\n  border: 1px solid var(--border-glass);\n  transition: all 0.3s ease;\n}\n\n.moneybro-card:hover {\n  transform: translateY(-5px);\n  border-color: rgba(255, 255, 255, 0.2);\n  box-shadow: var(--shadow-lg);\n}\n\n.moneybro-icon {\n  font-size: 3rem;\n  margin-bottom: 1.5rem;\n}\n\n.moneybro-card h3 {\n  font-size: 1.25rem;\n  margin-bottom: 1rem;\n  color: #ffffff;\n  font-weight: 700;\n}\n\n.moneybro-card p {\n  color: var(--text-muted);\n  line-height: 1.6;\n}\n\n/* CTA Section */\n.moneybro-cta {\n  text-align: center;\n  background: var(--grad-surface);\n  padding: 4rem 2rem;\n  border-radius: var(--radius-lg);\n  margin-bottom: 3rem;\n  border: 1px solid var(--border-glass);\n  box-shadow: var(--shadow-lg);\n}\n\n.moneybro-cta h2 {\n  font-size: 2rem;\n  margin-bottom: 1rem;\n  color: #ffffff;\n}\n\n.moneybro-cta p {\n  font-size: 1.1rem;\n  color: var(--text-muted);\n  margin-bottom: 2rem;\n}\n\n.moneybro-cta-btn {\n  background: var(--grad-primary);\n  color: #ffffff;\n  border: none;\n  padding: 1rem 2.5rem;\n  font-size: 1.1rem;\n  font-weight: 700;\n  border-radius: var(--radius-full);\n  cursor: pointer;\n  transition: all 0.3s ease;\n}\n\n.moneybro-cta-btn:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 4px 15px rgba(245, 158, 11, 0.4);\n}\n\n.moneybro-note {\n  font-size: 0.85rem;\n  color: var(--text-muted);\n  margin-top: 1.5rem;\n  display: block;\n}\n\n/* Customer Care Card */\n.customer-care-card {\n  background: var(--bg-glass-card);\n  backdrop-filter: blur(16px);\n  text-align: center;\n  padding: 3rem 2rem;\n  border-radius: var(--radius-lg);\n  margin-bottom: 3rem;\n  border: 1px solid var(--border-glass);\n  box-shadow: var(--shadow-lg);\n}\n\n.customer-care-card h3 {\n  font-size: 1.8rem;\n  margin-bottom: 1rem;\n  color: #ffffff;\n}\n\n.customer-care-card p {\n  font-size: 1.1rem;\n  margin-bottom: 2rem;\n  color: var(--text-muted);\n}\n\n.customer-care-btn {\n  display: inline-block;\n  background: rgba(255, 255, 255, 0.1);\n  color: #ffffff;\n  border: 1px solid rgba(255, 255, 255, 0.2);\n  padding: 1rem 2.5rem;\n  font-size: 1.1rem;\n  font-weight: 600;\n  border-radius: var(--radius-full);\n  text-decoration: none;\n  transition: all 0.3s ease;\n}\n\n.customer-care-btn:hover {\n  background: rgba(255, 255, 255, 0.2);\n  transform: translateY(-2px);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
